import axios from 'axios';

const BASE_API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

// "Request a demo" form on the landing page. The API emails the request to the
// ez11 team; `website` is a honeypot and must stay empty for real submissions.
export const submitContactRequest = async (data) => {
  const response = await axios.post(`${BASE_API}/public/contact`, data);
  return response.data;
};
